import http from "../http-common"
import accountHeader from './account-header'

class ChatDataService {
    //used in markerInTable.js
    initialize(idRecipient) {
        return http.post("/chats", { idRecipient: idRecipient }, { headers: accountHeader() })
    }
}
export default new ChatDataService()